import { useLenis } from "lenis/react";

export function useScrollTo() {
  const lenis = useLenis();
  return (target, offset = -64) => {
    const el = typeof target === "string" ? document.getElementById(target) : target;
    if (!el) return;
    if (lenis) lenis.scrollTo(el, { offset, duration: 1.2 });
    else el.scrollIntoView({ behavior: "smooth" });
  };
}
